import { ISportEvent } from '@frontend/oxygen/shared-utils';

export interface IfeaturedBybWidget {
    '@type'?: string;
    'sportName'?: string;
    'data': IfeaturedBybWidgetData[];
    'displayOrder'?: number;
    'marketCardVisibleSelections': number;
    'pageType'?: string;
    'publishedDevices'?: [];
    'segmentOrder'?: number;
    'segmented'?: boolean;
    'showAll': boolean;
    'showExpanded'?: boolean;
    'sortOrder'?: number;
    'sportId'?: number;
    'title': string;
    '_id'?: string;
}

export interface IfeaturedBybWidgetData extends ISportEvent {
    outcomesCount: number;
    marketStatusCode: string;
    event: ISportEvent;
    teamNames: string[];
    locations: string[];
    assetManagements: assetManagements[];
}

export interface assetManagements {
    originalname?: string;
    secondaryNames: string[];
    teamsImage?: any;

    id: string;
    primaryColour: string;
    secondaryColour: string;
    sportId: number;
    teamName: string;
}

export enum GA_CONSTANTS {
    WIDGET = 'widgets',
    BUILD_YOUR_BET = 'build your own bet',
    BYB_WIDGET = 'byb widget',
    NOT_APPLICABLE = 'not applicable',
}
export enum BYBW_CONST {
    BUILD_YOUR_OWN = 'BUILD YOUR  OWN',
}

export const DEFAULT_TEAM_COLOURS = {
    primary: '#777',
    secondary: '#675d5d',
};

export interface ITeamsExist {
    filename: string;
}
